module.exports = __webpack_public_path__ + "img/mrat_card_image.911864f0.jpg";